<template>
  <ActionGeneric label="Cancella" iconClass="fas fa-trash" :show-icons-only="showIconsOnly" :eventName="eventName" :btnClasses="btnClasses" :btnClassesMobile="btnClassesMobile" :disabled="disabled" @click="$emit('click', $event)" />
</template>

<script>

import actionMixin from './mixins/action';

export default {
  name: 'action-delete',
  mixins: [actionMixin],
  components: {
    ActionGeneric: () => import('./ActionGeneric'),
  },
};

</script>
